import React, { useEffect } from 'react';
import {
  Modal,
  Tabs,
  Card,
  Form,
  Row,
  Input,
  InputNumber,
  Col,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import InputCurrency from 'components/InputCurrency';
import InputRate from 'components/InputRate';
import ButtonOperation from 'components/ButtonOperation';
import _ from 'lodash';
import ParListSelect from 'components/ParListSelect';
import RateFormulaSelect from 'components/RateFormulaSelect';
import Value from 'components/Value';

const { TabPane } = Tabs;

export type SimpleServElementModalProps = {
  updatePreFinStep?: boolean;
  visible?: boolean;
  onSave: (serv: any, action: string) => void;
  onClose: any;
  record: any;
  ctesorder?: number;
};

const ConElemPrefinStepModal = (props: SimpleServElementModalProps) => {
  const {
    onSave,
    visible = false,
    onClose,
    record,
    ctesorder,
    updatePreFinStep = false,
  } = props;

  const [form] = useForm();

  const initialValues = record
    ? record
    : {
        cteid: 0,
        ctrid: 0,
        ctesid: _.random(1000000, 350000),
        ctesorder: ctesorder ?? 1,
        // ctesstartdate: moment().format('YYYY-MM-DD'),
        ctesduration: '' as any,
        ctesperiodicityunit: '' as any,
        ctesperiodicity: '' as any,
        enddate: '',
        calcmethod: '' as any,
        rateformula: '' as any,
        ratebasis: '' as any,
        ratespread: '' as any,
        nominalrate: '' as any,
        ctesstartamount: 0,
        ctesinterestamount: 0,
        ctesamortizedcoef: '' as any,
        ctesamortizedamount: '' as any,
        ctesrentalamount: 0,
        ctesoutstandingcoef: '' as any,
        ctesoutstandingamount: '' as any,
      };

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        cteid: record.cteid,
        ctrid: record.ctrid,
        ctesid: record.ctesid,
        ctesorder: record.ctesorder,
        ctesstartdate: record.ctesstartdate,
        ctesduration: record.ctesduration,
        ctesperiodicityunit: record.ctesperiodicityunit,
        ctesperiodicity: record.ctesperiodicity,
        enddate: record.enddate,
        calcmethod: record.calcmethod,
        rateformula: record.rateformula,
        ratebasis: record.ratebasis,
        ratespread: record.ratespread,
        nominalrate: record.nominalrate,
        ctesstartamount: record.ctesstartamount,
        ctesinterestamount: record.ctesinterestamount,
        ctesamortizedcoef: record.ctesamortizedcoef,
        ctesamortizedamount: record.ctesamortizedamount,
        ctesrentalamount: record.ctesrentalamount,
        ctesoutstandingcoef: record.ctesoutstandingcoef,
        ctesoutstandingamount: record.ctesoutstandingamount,
      });
    }
  }, [record]);

  return (
    (<div onClick={(e) => e.stopPropagation()}>
      <Modal
        open={visible}
        title={updatePreFinStep ? 'Update PreFinStep' : 'Add PreFinStep'}
        onCancel={() => {
          onClose();
        }}
        width="1000px"
        style={{ top: 20 }}
        footer={null}
        destroyOnClose
      >
        <Card bordered style={{ padding: 10 }}>
          <Form
            form={form}
            onFinish={(values) => {
              onSave(
                updatePreFinStep
                  ? {
                      ...record,
                      ...values,
                    }
                  : {
                      ...initialValues,
                      ...values,
                      ctesorder: ctesorder ?? 0 + 1,
                    },
                updatePreFinStep ? 'update' : 'create'
              );
              onClose();
            }}
            initialValues={initialValues}
            layout="vertical"
          >
            <Row justify="end" gutter={10} style={{ marginBottom: 10 }}>
              <Col>
                <ButtonOperation
                  comcode="cancel"
                  htmlType="button"
                  onClick={() => {}}
                />
              </Col>
              <Col>
                <ButtonOperation
                  comcode={updatePreFinStep ? 'update' : 'add'}
                  htmlType="submit"
                  type="primary"
                />
              </Col>
            </Row>
            <Row gutter={10}>
              <FormInput col md={6} name="ctesorder">
                <InputNumber />
              </FormInput>

              <FormInput col md={6} name="ctesstartdate">
                <Value />
              </FormInput>

              <FormInput col md={6} name="enddate">
                <Value />
              </FormInput>
              <FormInput col md={6} name="calcmethod">
                <ParListSelect parcode="PARTINVMET" />
              </FormInput>

              <FormInput col md={6} name="ctesduration">
                <InputNumber />
              </FormInput>

              <FormInput
                col
                md={6}
                name="ctesperiodicity"
                comcode="ctesperiodicity"
              >
                <Input />
              </FormInput>

              <FormInput col md={6} name="ctesperiodicityunit">
                <ParListSelect parcode="PERIOD" />
              </FormInput>
              <Col span={6} />
              <FormInput col md={6} name="ratebasis">
                <ParListSelect parcode="CALBASIS" />
              </FormInput>

              <FormInput col md={6} name="rateformula" comcode="rateformula">
                <RateFormulaSelect
                  params={{
                    formulatype: 'NOMINAL',
                  }}
                />
              </FormInput>

              <FormInput col md={6} name="ratespread" comcode="ratespread">
                <InputRate />
              </FormInput>

              <FormInput col md={6} name="nominalrate" comcode="nominalrate">
                <InputRate />
              </FormInput>

              <FormInput col md={6} name="ctesstartamount">
                <InputCurrency
                  currcode={localStorage.getItem('currcode') ?? ''}
                />
              </FormInput>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  return (
                    <FormInput col md={6} name="ctesamortizedcoef">
                      <InputNumber
                        onChange={(val) => {
                          form.setFieldsValue({
                            ctesamortizedamount:
                              (((val as number) *
                                getFieldValue('ctesstartamount')) as number) /
                              100,
                            ctesoutstandingamount:
                              (getFieldValue('ctesstartamount') as number) -
                              (((val as number) *
                                getFieldValue('ctesstartamount')) as number) /
                                100,
                          });
                        }}
                      />
                    </FormInput>
                  );
                }}
              </Form.Item>

              <FormInput col md={6} name="ctesamortizedamount">
                <InputCurrency
                  currcode={localStorage.getItem('currcode') ?? ''}
                />
              </FormInput>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  return (
                    <FormInput col md={6} name="ctesoutstandingcoef">
                      <InputNumber
                        onChange={(val) => {
                          form.setFieldsValue({
                            ctesoutstandingamount:
                              (getFieldValue('ctesstartamount') as number) -
                              (((val as number) *
                                getFieldValue('ctesstartamount')) as number) /
                                100,
                          });
                        }}
                      />
                    </FormInput>
                  );
                }}
              </Form.Item>

              <FormInput col md={6} name="ctesoutstandingamount">
                <InputCurrency
                  currcode={localStorage.getItem('currcode') ?? ''}
                />
              </FormInput>
            </Row>
          </Form>
        </Card>
      </Modal>
    </div>)
  );
};

export default ConElemPrefinStepModal;
